export default {
  created() {
    Nova.$on('metric-refresh', this.handleMetricRefresh)

    Nova.$on('resources-deleted', this.fetch)
    Nova.$on('resources-restored', this.fetch)

    if (this.card.refreshWhenActionRuns) {
      Nova.$on('action-executed', this.fetch)
    }
  },

  beforeUnmount() {
    Nova.$off('metric-refresh', this.handleMetricRefresh)
    Nova.$off('resources-deleted', this.fetch)
    Nova.$off('resources-restored', this.fetch)
    Nova.$off('action-executed', this.fetch)
  },

  methods: {
    /**
     * Refresh this metric. When the event carries a resourceName, only
     * metrics on that resource index respond — so main-points live updates
     * do not thrash unrelated dashboard cards in another tab.
     *
     * @param  {string|{resourceName?: string}|undefined}  payload
     */
    handleMetricRefresh(payload) {
      const target =
        typeof payload === 'string'
          ? payload
          : payload && typeof payload === 'object'
            ? payload.resourceName
            : null

      if (target && (!this.resourceName || this.resourceName !== target)) {
        return
      }

      this.fetch()
    },
  },
}
